import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.css']
})
export class MovimientosComponent implements OnInit {

  public Config
  constructor(private dialogRef: MatDialogRef<MovimientosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService) { }

  ngOnInit(): void {
    this.Config = JSON.parse(this._userService.GetsessionStorage('config'));
    console.log(this.data)
    console.log(this.Config)
  }

}
